// Both forms keep these fields flat at the top level under identical names, so the mapping
// is the parent form's concern rather than the cards'.
export const SECTION_DETAILS_FIELDS = {
  name: 'name',
  external_id: 'external_id',
  integration_id: 'integration_id',
  accounting_id: 'accounting_id',
} as const;

export const SECTION_CONTEXT_FIELDS = {
  customer_group: 'customer_group',
  price_lists: 'price_lists',
  sales_agent_groups: 'sales_agent_groups',
  payment_on_account_enabled: 'payment_on_account_enabled',
  payment_on_account: 'payment_on_account',
} as const;
